import { ReactElement } from "react";

export const getContainersRatio = (
    /** bcr = getBoundingClientRect */
    bcrDistance: number,
    bcrSize: number,
    cursorDistance: number,
    minSizeRatio: number,
    maxSizeRatio: number,
) => {
    const distanceDelta = cursorDistance - bcrDistance;
    const containersRatio = distanceDelta / bcrSize;

    let firstContainerPercentage = containersRatio * 100;

    if (firstContainerPercentage > maxSizeRatio)
        firstContainerPercentage = maxSizeRatio;

    if (firstContainerPercentage < minSizeRatio)
        firstContainerPercentage = minSizeRatio;

    const secondContainerPercentage = 100 - firstContainerPercentage;

    return ({ firstContainerPercentage, secondContainerPercentage });
};

export const getMinContainerPercentage = (
    currentPercentages: readonly number[],
    minLeftDraggedPercentage: number,
    draggerIndex: number,
) => {
    let minLeftPercentage = minLeftDraggedPercentage;

    for (let i = 0; i < draggerIndex; i++) {
        minLeftPercentage += currentPercentages[i];
    }

    return minLeftPercentage;
};

export const getMaxContainerPercentage = (
    currentPercentages: readonly number[],
    minRightDraggedPercentage: number,
    draggerIndex: number,
) => {
    let minRightPercentage = minRightDraggedPercentage;

    for (let i = currentPercentages.length - 1; i > draggerIndex + 1; i--) {
        minRightPercentage += currentPercentages[i];
    }

    return 100 - minRightPercentage;
};

export const getPreviousBlockPercentage = (currentBlocksPercentages: readonly number[], previousContainerPercentage: number, draggerIndex: number) => {
    let previousBlockPercentage = previousContainerPercentage;

    for (let i = 0; i < draggerIndex; i++) {
        previousBlockPercentage -= currentBlocksPercentages[i];
    }

    return previousBlockPercentage;
};

export const getNextBlockPercentage = (currentBlocksPercentages: readonly number[], nextContainerPercentage: number, draggerIndex: number) => {
    let previousBlockPercentage = nextContainerPercentage;

    for (let i = currentBlocksPercentages.length - 1; i > draggerIndex + 1; i--) {
        previousBlockPercentage -= currentBlocksPercentages[i];
    }

    return previousBlockPercentage;
};

export const validateSplitPanelProps = (children: readonly ReactElement[], minSizePercentages: readonly number[], defaultPercentages?: readonly number[]) => {
    if (defaultPercentages !== undefined) {
        if (defaultPercentages.length !== children.length)
            throw new Error("Number of defaultPercentages doesn't equal to the number of SplitPanel´s children.");

        if (minSizePercentages.length !== children.length)
            throw new Error("Number of minSizePercentages doesn't equal to the number of SplitPanel´s children.");

        for (let i = 0; i < minSizePercentages.length; i++) {
            if (minSizePercentages[i] > defaultPercentages[i]) {
                throw new Error(`Min percentage size cannot be greater than the container´s size.
                minSizePercentages has on position ${i} value ${minSizePercentages[i]}% while width/height of the container on position ${i} is ${defaultPercentages[i]}%.`);
            }
        }

        const sumOfDefaultPercentages = defaultPercentages.reduce((prevValue, nextValue) => prevValue + nextValue, 0);
        const sumOfMinPercentages = minSizePercentages.reduce((prevValue, nextValue) => prevValue + nextValue, 0);

        if (sumOfMinPercentages > 100 || sumOfDefaultPercentages > 100)
            throw new Error(`Sum of the items in the array of prop 'minSizePercentages' or 'defaultPercentages' cannot be greater than 100%. Your values are: ${sumOfMinPercentages}% and ${sumOfDefaultPercentages}%`);
    }
};
